// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__P35EP","loader":"loader_loader__k-4YN","load4":"loader_load4__t-xP6"};